/* eslint-disable no-use-before-define */
// React
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Lodash
import _, { debounce } from 'lodash';

// React Spectrum Components
import {
  Item,
  Picker,
  SearchField,
} from '@adobe/react-spectrum';

// React Router
import { withRouter } from '../withRouter';

// Redux Actions
import { addSingleFilter } from '../../actions/filterActions';

// Styles
import '../../styles/FilterCommon.scss';
import '../../styles/LocationFilter.scss';

const LocationFilter = ({
  appliedFilters, addSingleFilterAction,
  router,
}) => {
  // State hooks
  const [locationQueryType, setLocationQueryType] = useState();
  const [textSearch, setTextSearch] = useState('');

  useEffect(() => {
    setLocationQueryType(_.has(appliedFilters, 'locationType') ? appliedFilters.locationType : 'all');
    setTextSearch(_.has(appliedFilters, 'address') ? appliedFilters.address : '');
  }, [appliedFilters]);

  const debouncedFetchResults = useCallback(
    debounce((searchQuery) => {
      addSingleFilterAction({ name: 'address', value: searchQuery }, router);
    }, 800),
    [],
  );

  // Clean up the debounce when the component unmounts
  useEffect(() => () => {
    debouncedFetchResults.cancel(); // Clean up debounce function on unmount
  }, [debouncedFetchResults]);

  const handleChange = (val) => {
    setLocationQueryType(val);
    addSingleFilterAction({ name: 'locationType', value: val }, router);
  };

  const handleTextSearch = (val) => {
    setTextSearch(val);
    debouncedFetchResults(val);
  };
  // Render Geo Filter
  const renderGeoFilter = () => (
    <div className="locationFilterContainer">
      <Picker selectedKey={locationQueryType} UNSAFE_style={{ width: '100%' }} onSelectionChange={handleChange}>
        <Item key="all">All locations served</Item>
        <Item key="physical-location">Has physical location</Item>
        <Item key="hqaddress">Headquarters</Item>
      </Picker>
      <SearchField
        autoFocus
        placeholder="Search location"
        value={textSearch}
        onChange={handleTextSearch}
        UNSAFE_style={{ width: '100%' }}
      />
    </div>
  );

  return (
    <div className="cmp-locationFilter" id="location-filter">
      {renderGeoFilter()}
    </div>
  );
};

LocationFilter.propTypes = {
  appliedFilters: PropTypes.shape({
    locationQueryType: PropTypes.shape({
      geo: PropTypes.string,
      country: PropTypes.string,
    }),
    address: PropTypes.shape({
      geo: PropTypes.string,
      country: PropTypes.string,
    }),
  }),
  addSingleFilterAction: PropTypes.func.isRequired,
  router: PropTypes.shape({}).isRequired,
};

LocationFilter.defaultProps = {
  appliedFilters: {},
};

const mapStateToProps = (state) => ({
  appliedFilters: state.filter.selected,
});

const mapDispatchToProps = {
  addSingleFilterAction: addSingleFilter,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationFilter));
